import { render, staticRenderFns } from "./ValuationTable.vue?vue&type=template&id=08977efb"
import script from "./ValuationTable.vue?vue&type=script&lang=ts"
export * from "./ValuationTable.vue?vue&type=script&lang=ts"
import style0 from "./ValuationTable.vue?vue&type=style&index=0&id=08977efb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports